import { Stack } from "native-base";

export default Stack;